var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "projects-filter" },
    [
      _c(
        "li",
        {
          staticClass: "projects-filter__item projects-filter__item--all",
          class: { "projects-filter__item--active": _vm.activeFilterId === 0 },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.updateFilter(0)
            }
          }
        },
        [_vm._v("All "), _c("sup", [_vm._v(_vm._s(_vm.total))])]
      ),
      _vm._v(" "),
      _vm._l(_vm.filters, function(filter) {
        return _c(
          "li",
          {
            ref: "category-" + filter.id,
            refInFor: true,
            staticClass: "projects-filter__item",
            class: {
              "projects-filter__item--active": _vm.activeFilterId === filter.id
            },
            attrs: { "v-key": filter.id },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.updateFilter(filter.id)
              }
            }
          },
          [
            _vm._v(_vm._s(filter.name)),
            _c("sup", { staticClass: "projects-filter__item-sup" }, [
              _vm._v(_vm._s(filter.count))
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }